import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-inputchips',
  templateUrl: './inputchips.component.html',
  styleUrls: ['./inputchips.component.scss']
})
export class InputchipsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
